import React, { useEffect, useRef } from 'react';
import '../styles/Principles.css';

function Principles() {
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    // Store the current refs to avoid the cleanup warning
    const currentRefs = [...cardRefs.current];

    currentRefs.forEach(card => {
      if (card) {
        card.style.opacity = '0';
        card.style.transform = 'translateY(30px)';
        card.style.transition = 'all 0.6s ease';
        observer.observe(card);
      }
    });

    return () => {
      currentRefs.forEach(card => {
        if (card) observer.unobserve(card);
      });
    };
  }, []);

  return (
    <section className="principles" id="principles">
      <div className="container">
        <h2 className="section-title">The TRO Method</h2>
        <p className="section-subtitle">Transform your practice through the power of neutrality. Our unique approach combines ancient wisdom with modern flow techniques.</p>
        
        <div className="principles-grid">
          <div 
            className="principle-card" 
            ref={el => cardRefs.current[0] = el}
          >
            <div className="principle-icon">T</div>
            <h3 className="principle-title">Toxicity Release</h3>
            <p className="principle-description">Dynamic sequences that help release physical and emotional toxins through powerful vinyasa flows and heat-building poses.</p>
          </div>
          
          <div 
            className="principle-card"
            ref={el => cardRefs.current[1] = el}
          >
            <div className="principle-icon">R</div>
            <h3 className="principle-title">Regulation & Balance</h3>
            <p className="principle-description">Find your center through controlled breathing and mindful transitions that regulate your nervous system and energy flow.</p>
          </div>
          
          <div 
            className="principle-card"
            ref={el => cardRefs.current[2] = el}
          >
            <div className="principle-icon">O</div>
            <h3 className="principle-title">Oscillation & Flow</h3>
            <p className="principle-description">Experience the rhythm of movement as you flow between poses, creating a meditative dance that harmonizes body and mind.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Principles;
